import type { FC } from "react";

export interface InterviewSectionDefinitionCardSkeletonProps {}

export const InterviewSectionCardSkeleton: FC<
  InterviewSectionDefinitionCardSkeletonProps
> = (props) => {
  return (
    <div className="animate-pulse space-y-2.5 px-3 py-2">
      <div className="h-4 max-w-56 rounded-full bg-gray-300" />
      <div className="h-3 max-w-96 rounded-full bg-gray-300" />
    </div>
  );
};
